<template>
  <div class="media">
    <div class="icon-main icon-main-mobile">
      <div class="icon-round">
        <svg width="25" height="25" fill="none">
          <use xlink:href="#WallClockW" />
        </svg>
      </div>
    </div>
    <div class="media-body" v-if="isFloorTableAvailable.table_id === undefined">
      <div class="timeline-card">
        <h4 class="title">{{ _T('Delivery Time') }}</h4>
        <div class="delivery-content mb-2" v-if="!future_order">
          <h5 class="delivery-time" v-html="deliveryTime"></h5>
        </div>
        <div v-else class="delivery-content mt-2 mb-2">
          <ul class="d-flex justify-content-between align-items-baseline">
            <li class="col-sm-7">
              <b>{{ _T('Date') }}</b>
              <div class="d-flex align-items-center mt-1">
                <img
                  src="/images/svg/checkout/outline-date.svg"
                  alt=""
                  class="img-fluid"
                />
                <span class="font-size-date" v-if="future_order.future_date">
                  {{ date_time_format(future_order.future_date) }}
                </span>
              </div>
            </li>
            <li class="col-sm-5">
              <b>{{ _T('Time') }}</b>
              <div class="d-flex align-items-center mt-1">
                <img
                  src="/images/svg/checkout/outline-access_time.svg"
                  alt=""
                  class="img-fluid"
                />
                <span class="font-size-date">
                  <!--{{ future_order.future_time.time_from }} - -->
                  {{ future_order.future_time.time_to }}
                </span>
              </div>
            </li>
            <li>
              &nbsp;
            </li>
          </ul>
        </div>
        <div
          v-if="
            (isModuleEnable(CONST.MODULE_FUTURE_ORDERS) || !domainBasedBrand) &&
              currentStore
          "
        >
          <button
            type="button"
            class="btn btn-outline w-100"
            data-toggle="modal"
            @click="showDeliveryTime"
          >
            {{ _T('Schedule for later') }}
          </button>
        </div>
        <div v-else>
          <h4 class="title">
            {{
              _T(
                'Please select delivery area than you can schedule it for later.'
              )
            }}
            {{ currentStore }}
          </h4>
        </div>
      </div>
    </div>
    <delivery-time-modal></delivery-time-modal>
  </div>
</template>
<script>
import DeliveryTimeModal from './DeliveryTimeModel'
import { mapGetters } from 'vuex'
import Delivery from '@/mixins/Delivery'
export default {
  mixins: [Delivery],
  components: {
    DeliveryTimeModal,
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'currentStore',
      'future_order',
      'isModuleEnable',
      'domainBasedBrand',
      'date_time_format',
      'isFloorTableAvailable',
    ]),
  },
  methods: {
    showDeliveryTime() {
      this.$bvModal.show('delivery-time-table')
    },
    showModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
  },
}
</script>
<style lang="scss">
.delivery-time {
  span {
    display: inline !important;
  }
}
@media (max-width: 575px) {
  .icon-main-mobile {
    display: none;
  }
}
.font-size-date {
  font-size: 14px;
  padding-left: 5px;
}
</style>
<style lang="scss" scoped>
.body-rtl {
  .media {
    .media-body {
      .timeline-card {
        text-align: right;
      }
    }
  }
}
</style>
